import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { UnreadProvider } from "@/context/UnreadContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";

// Route-based code splitting — büyük sayfalar yalnızca ziyaret edildiğinde yüklenir
// Bu, ilk açılışta indirilen JS'yi %60-70 azaltır (özellikle iPad 3G bağlantısında etkili)
const Dashboard          = lazy(() => import("@/pages/Dashboard"));
const Customers          = lazy(() => import("@/pages/Customers"));
const CustomerDetail     = lazy(() => import("@/pages/CustomerDetail"));
const Motorcycles        = lazy(() => import("@/pages/Motorcycles"));
const MotorcycleDetail   = lazy(() => import("@/pages/MotorcycleDetail"));
const ServiceRecords     = lazy(() => import("@/pages/ServiceRecords"));
const ServiceRecordDetail= lazy(() => import("@/pages/ServiceRecordDetail"));
const ServiceIntake      = lazy(() => import("@/pages/ServiceIntake"));
const UnpaidPayments     = lazy(() => import("@/pages/UnpaidPayments"));
const Settings           = lazy(() => import("@/pages/Settings"));
const Inventory          = lazy(() => import("@/pages/Inventory"));
const Appointments       = lazy(() => import("@/pages/Appointments"));
const CashBook           = lazy(() => import("@/pages/CashBook"));
const DuplicatesAdmin    = lazy(() => import("@/pages/DuplicatesAdmin"));
const GeneralGroup       = lazy(() => import("@/pages/GeneralGroup"));
const BarkodTest         = lazy(() => import("@/pages/BarkodTest"));

function PageFallback() {
  return (
    <div className="flex items-center justify-center py-20 text-slate-400 text-sm" data-testid="page-loading">
      <div className="animate-spin rounded-full h-6 w-6 border-2 border-slate-300 border-t-primary mr-3" />
      Yükleniyor...
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <UnreadProvider>
            <Toaster position="bottom-right" richColors theme="system" />
            <Suspense fallback={<PageFallback />}>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/musteriler" element={<Customers />} />
                  <Route path="/musteriler/:id" element={<CustomerDetail />} />
                  <Route path="/motorlar" element={<Motorcycles />} />
                  <Route path="/motorlar/:id" element={<MotorcycleDetail />} />
                  <Route path="/servis-kayitlari" element={<ServiceRecords />} />
                  <Route path="/servis-kayitlari/yeni" element={<ServiceIntake />} />
                  <Route path="/servis-kayitlari/:id" element={<ServiceRecordDetail />} />
                  <Route path="/odeme-bekleyenler" element={<UnpaidPayments />} />
                  <Route path="/stok" element={<Inventory />} />
                  <Route path="/randevular" element={<Appointments />} />
                  <Route path="/kasa" element={<CashBook />} />
                  <Route path="/admin/mukerrer" element={<DuplicatesAdmin />} />
                  <Route path="/ayarlar" element={<Settings />} />
                  <Route path="/genel-grup" element={<GeneralGroup />} />
                  <Route path="/barkod-test" element={<BarkodTest />} />
                </Route>
              </Routes>
            </Suspense>
          </UnreadProvider>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;

